export default __webpack_public_path__ + "static/media/darktemplaraction.4c97bb7b.png";